import * as types from "../../types";

export default {
  [types.REGISTRATION_UPDATE](state, { payload }) {
    Object.assign(state.profile, payload);
  },

  [types.REGISTRATION_ERRORS_SET](state, { errors }) {
    state.errors = errors.reduce(
      (acc, error) => ({
        ...acc,
        [error.path]: [...(acc[error.path] || []), error.message],
      }),
      {}
    );
  },
};
